import { Locations } from '../models/locations'

export interface LocationsStateType {
  locations: Locations[]
  location: Locations | null
}

const LocationsState: () => LocationsStateType = () => ({
  locations: [],
  location: null,
})

export default LocationsState
